import React from 'react'

import * as styles from './resellersHero.module.scss'
import Hero from 'common/Hero'
import ResellerModal from '../../../modals/ResellerModal'

export default function ResellersHero({ media, title, subtitle, ctas }) {
  return (
    <Hero
      className={styles.hero}
      mediaClassName="full-width"
      title={title}
      subtitle={subtitle}
      media={media}
      customCta={() => <HeroCta cta={ctas[0]} />}
      loading="eager"
      fullMobile
      fullDesktop
    />
  )
}

const HeroCta = ({ cta }) => {
  return (
    <div className={styles.customCta}>
      <ResellerModal text={cta.text} />
    </div>
  )
}
